module.exports = __webpack_public_path__ + "img/star_off.4e9c8f17.svg";